/* C25/C26 · qt-favorites.js — the ONLY QT file touching localStorage (key 'qt-favorites', product
   handles only, every access in try/catch; without storage the toggles stay hidden and the shop works).
   Hearts, PDP button, header count, toast and the favourites page. Page cards are rendered fresh by
   Shopify (section qt-fav-card on /products/<handle>), never from stored data; a gone product is dropped.
   Cross-tab sync via the storage event. Spec: 01-componenten.md C25, C26. */
const KEY = 'qt-favorites';
const $ = (selector, scope = document) => scope.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);
const page = () => $('[data-qt-fav-page]');
const set = (el, text) => el.textContent != text && (el.textContent = text); // avoid observer loops
let favs;
let timer;
let frame;

try {
  favs = JSON.parse(localStorage.getItem(KEY)) || [];
} catch {}
const save = () => {
  try {
    localStorage.setItem(KEY, JSON.stringify(favs));
  } catch {}
};

function sync() {
  $$('[data-qt-fav]').forEach((button) => {
    const on = favs.includes(button.dataset.qtFav);
    const text = $('[data-fav-text]', button);
    button.hidden = false;
    button.setAttribute('aria-pressed', on);
    if (button.dataset.labelAdd) button.setAttribute('aria-label', button.dataset[on ? 'labelRemove' : 'labelAdd']);
    if (text) set(text, text.dataset[on ? 'saved' : 'add']);
  });
  $$('[data-qt-fav-link]').forEach((link) => {
    link.hidden = !favs.length;
    set($('[data-fav-count]', link), favs.length);
    link.setAttribute('aria-label', link.dataset.label.replace('[count]', favs.length));
  });
  const root = page();
  if (!root || root.ariaBusy == 'true') return;
  root.querySelectorAll('[data-fav-card]').forEach((card) => favs.includes(card.dataset.favCard) || card.remove());
  const count = root.querySelectorAll('[data-fav-card]').length;
  $('[data-fav-empty]', root).hidden = count > 0;
  set($('[data-fav-page-count]', root), count ? root.dataset[count == 1 ? 'one' : 'other'].replace('[count]', count) : '');
}

async function render() {
  const root = page();
  if (!root) return sync();
  root.ariaBusy = 'true';
  const cards = await Promise.all(
    favs.map((handle) =>
      fetch(`${Shopify.routes.root}products/${handle}?section_id=qt-fav-card`)
        .then((response) => (response.ok || response.status == 404 ? response.text() : Promise.reject()))
        .then((html) => {
          // An answer without a card means the product is gone (404, or an empty render): drop it.
          if (!html.includes('data-fav-card')) favs = favs.filter((h) => h != handle);
          return html.replace(/^\s*<div[^>]*>|<\/div>\s*$/g, ''); // strip the section wrapper
        })
        .catch(() => '') // offline, 429, 5xx: keep the handle
    )
  );
  save();
  $('[data-fav-list]', root).innerHTML = cards.join('');
  root.ariaBusy = 'false';
  sync();
}

function notify(on, title) {
  const toast = $('[data-qt-fav-toast]');
  if (!toast) return;
  const gift = $('.qt-gift-popup:not([hidden])');
  toast.style.bottom = gift ? `calc(var(--qt-float-popup-bottom) + var(--qt-float-gap) + ${gift.offsetHeight}px)` : '';
  $('[data-fav-toast-text]', toast).innerHTML = on
    ? $('[data-added]', toast).innerHTML.replace('[title]', title.replace(/[<&]/g, ''))
    : $('[data-removed]', toast).innerHTML;
  toast.classList.add('is-visible');
  clearTimeout(timer);
  timer = setTimeout(() => toast.classList.remove('is-visible'), 4000);
}

if (favs) {
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-qt-fav]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation(); // cards navigate on click
      const handle = button.dataset.qtFav;
      const on = !favs.includes(handle);
      favs = on ? [handle, ...favs] : favs.filter((h) => h != handle);
      save();
      sync();
      notify(on, button.dataset.title);
    },
    true
  );
  addEventListener('storage', (event) => {
    if (event.key != KEY) return;
    try {
      favs = JSON.parse(event.newValue) || [];
    } catch {
      favs = [];
    }
    render();
  });
  document.addEventListener('shopify:section:load', render);
  // Cards arrive later (filters, infinite scroll, drawers): reveal and sync their toggles.
  new MutationObserver(() => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(sync);
  }).observe(document.body, { childList: true, subtree: true });
  render();
}
